// extracted by mini-css-extract-plugin
module.exports = {"root":"Gaming_qmee_root___3FVc"};